module.exports = __webpack_public_path__ + "assets/fonts/node_modules/deltoid/assets/fonts//payu-icons.eot";